import React from 'react';

export default function Services({ services }) {
    return (
        <section id="servicos" className="py-20 px-4 bg-gray-50">
            <div className="max-w-7xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-black">
                    O que você pode fazer <span className="text-cyan-400">comigo</span>
                </h2>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {services.map((service, idx) => (
                        <div key={idx} className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition border-l-4 border-cyan-400">
                            <div className="text-4xl mb-4">{service.icon}</div>
                            <h3 className="text-xl font-bold mb-3 text-black">{service.title}</h3>
                            <p className="text-gray-600">{service.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
